module.exports = __webpack_public_path__ + "img/closed_menu.efc8c52d.svg";